import { Tooltip as MantineTooltip, type TooltipProps as MantineTooltipProps } from '@mantine/core';
import { FONT_WEIGHTS } from 'src/UI/theme/theme';

type TooltipProps = MantineTooltipProps;

export function Tooltip({ styles, ...props }: TooltipProps) {
  return (
    <MantineTooltip
      styles={{
        tooltip: {
          backgroundColor: 'var(--mantine-color-gray-10)',
          color: '#FFFFFF',
          borderRadius: 15,
          paddingTop: 2,
          paddingBottom: 2,
          paddingLeft: 'var(--mantine-spacing-xs)',
          paddingRight: 'var(--mantine-spacing-xs)',
          fontSize: 'var(--mantine-font-size-xs)',
          fontWeight: FONT_WEIGHTS.medium,
        },
        ...styles,
      }}
      {...props}
    />
  );
}
